import { useTranslation } from 'react-i18next';
import CollectionPage from '~/components/module/setup/CollectionPage';
import { str } from '~/components/module/setup/cells';
import { staffRoleAdapter } from '~/apis/staff';
import { STAFF_FEATURES } from '~/utils/constants/staffFeatures';
import { IFormField } from '~/utils/interface/setup';

const fields: IFormField[] = [
  { name: 'name', labelKey: 'pages.roles.name', type: 'text', required: true },
  { name: 'description', labelKey: 'pages.roles.description', type: 'text' },
  {
    name: 'features',
    labelKey: 'pages.roles.pages',
    type: 'checkboxGroup',
    required: true,
    options: STAFF_FEATURES.map((feature) => ({ value: feature.key, labelKey: feature.navKey })),
  },
];

// Custom roles for internal staff: pick the admin pages a role can open, then assign the role to users.
const Roles = () => {
  const { t } = useTranslation();
  const pageNames = (value: unknown) =>
    str(value as string)
      .split(',')
      .filter(Boolean)
      .map((key) => t(STAFF_FEATURES.find((feature) => feature.key === key)?.navKey ?? key))
      .join(', ');

  return (
    <CollectionPage
      i18nPrefix='pages.roles'
      adapter={staffRoleAdapter}
      fields={fields}
      defaultForm={{ features: '' }}
      getTitle={(form) => str(form.name)}
      columns={[
        { key: 'name', labelKey: 'pages.roles.name', render: (form) => <span className='font-medium text-foreground'>{str(form.name)}</span> },
        { key: 'description', labelKey: 'pages.roles.description', render: (form) => str(form.description) },
        { key: 'pages', labelKey: 'pages.roles.pages', render: (form) => pageNames(form.features) },
        { key: 'users', labelKey: 'pages.roles.users', render: (form) => str(form.userCount) },
      ]}
    />
  );
};

export default Roles;
